import React from "react";
import {useFunnelNavigation} from "../../hooks/useFunnelNavigation";
import {StepHeader} from "../common/StepHeader";
import {Footer} from "../common/Footer";

// const calculateBMR = (userData) => {
//   // Basic BMR calculation using Mifflin-St Jeor Equation
//   const { gender, weight, height, birthday } = userData;
//
//   // Convert weight to kg if it's in lbs
//   const weightInKg =
//     weight.unit === "imperial"
//       ? Number(weight.weight) * 0.453592
//       : Number(weight.weight);
//
//   // Convert height to cm if it's in feet/inches
//   let heightInCm;
//   if (height.unit === "imperial") {
//     const totalInches = Number(height.feet) * 12 + Number(height.inches);
//     heightInCm = totalInches * 2.54;
//   } else {
//     heightInCm = Number(height.cm);
//   }
//
//   // Calculate age
//   const today = new Date();
//   const birthDate = new Date(birthday);
//   const age = today.getFullYear() - birthDate.getFullYear();
//
//   // Mifflin-St Jeor Equation
//   let bmr;
//   if (gender === "woman") {
//     bmr = 10 * weightInKg + 6.25 * heightInCm - 5 * age - 161;
//   } else {
//     bmr = 10 * weightInKg + 6.25 * heightInCm - 5 * age + 5;
//   }
//
//   return Math.round(bmr);
// };

export function NutritionReport({config}) {
    const {nextStep} = useFunnelNavigation();
    const bmr = 1800; // Replace with actual BMR calculation

    return (
        <div className="px-4">
            <StepHeader
                title={config.title}
                subtitle={config.subtitle}
                order={config.headerOrder}
            />

            {/* Main content container */}
            <div className="bg-white rounded-2xl p-6 space-y-6">
                {/* BMR Section */}
                <div className="text-center">
                    <h3 className="text-lg font-medium text-gray-900 mb-2">
                        BMR (Basal Metabolic Rate)
                    </h3>
                    <p className="text-4xl font-bold text-green-500">
                        {bmr} Cal
                        <span className="text-base font-normal text-gray-500">
              {" "}
                            per day
            </span>
                    </p>
                </div>

                {/* Chart Section */}
                <div className="space-y-4">
                    <img
                        src="/donut-chart.png"
                        alt="Nutrition Distribution"
                        className="w-3/4 mx-auto"
                    />

                    {/* Legend */}
                    <div className="flex justify-center gap-4">
                        <div className="flex items-center">
                            <div className="w-3 h-3 rounded-full bg-blue-500 mr-1"></div>
                            <span className="text-sm text-gray-600">Carbs</span>
                        </div>
                        <div className="flex items-center">
                            <div className="w-3 h-3 rounded-full bg-green-500 mr-1"></div>
                            <span className="text-sm text-gray-600">Proteins</span>
                        </div>
                        <div className="flex items-center">
                            <div className="w-3 h-3 rounded-full bg-orange-500 mr-1"></div>
                            <span className="text-sm text-gray-600">Fats</span>
                        </div>
                    </div>
                </div>
            </div>

            <Footer onClick={nextStep}>{config.buttonText || "Continue"}</Footer>
        </div>
    );
}
